module.exports = __webpack_public_path__ + "img/icons-show-stickers.4e420bf.svg";